import axios from "axios"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { useSearchParams } from 'react-router-dom';
interface TProps {
    setStepper: any
    metadataPayload: any
}
const Stepper2 = ({ setStepper, metadataPayload }: TProps) => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const [accounts, setAccounts] = useState<any>([])
    const [loader, setLoader] = useState(false)
    useEffect(() => {
        if (metadataPayload) {
            const data: any = []
            console.log(metadataPayload)
            metadataPayload.accounts.map((item: any) => {
                data.push({
                    id: item.id,
                    value: 0
                })
            })
            setAccounts([...data])
        }
    }, [])
    const setAccountsValue = (index: number, value: number) => {
        accounts[index].value = value
        setAccounts([...accounts])
    }
    const handleFormSubmit = async () => {
        setLoader(true)
        const promises = accounts.map(async (item: any) => {
            try {
                const payload = {
                    account_id: item.id,
                    amount: item.value,
                    email: searchParams.get("email") ||"nadeembashir21@gmail.com",
                    data: {data: "test data"},
                }
                const data = await axios.post(process.env.REACT_APP_API_URL + "save-transaction", payload)
                return data;
            }
            catch (e) {
                console.log(e)
                setLoader(false)
            }
        })
        console.log(promises)
        const results = await Promise.all(promises);
        setLoader(false)
        navigate('/rate')
    }
    return (
        <>
            {loader ?
                <div role="status" className="spinners">
                    <svg aria-hidden="true" className="w-16 h-16 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                    </svg>
                    <span className="sr-only">Loading...</span>
                </div>
                : null}
            <div className="max-w-xl mx-auto w-full">
                <div className="bg-white p-6 rounded-lg shadow-lg max-w-xl w-full max-w-[38rem]">

                    <div className="mb-4 mx-auto text-center">
                        <h1 className="font-semibold text-xl mb-2 mx-auto text-center">What account(s) would you like to transfer from?</h1>
                        <p>Select which account to transfer from.</p>
                    </div>

                    <form>
                        {metadataPayload && metadataPayload?.accounts.map((item: any, index: number) => (
                            <div className="bg-gray-100 rounded-md p-5 mt-3 bg-[#F8FAFF]" key={index}>
                                <div>
                                    <div className="flex items-center justify-between">
                                        <img className="h-12 w-12" src="https://logo.clearbit.com/jpmorganchase.com" alt="wallet" /><div className="flex items-center">
                                            <label className="ml-2 flex items-center">
                                                <span className="font-semibold text-gray-400">{item.name}</span>

                                            </label>
                                        </div>
                                        <div className="text-right">
                                            <span className="font-semibold"><span>${accounts[index]?.value?.toFixed(2)}</span></span>
                                        </div>

                                    </div>

                                    <div className="relative mb-1">
                                        <label htmlFor="range-value-1" className="sr-only">Labels range</label>
                                        <input id="range-value-1" type="range" min="0" max="110" step="1" className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" value={accounts[index]?.value} onChange={(e) => setAccountsValue(index, Number(e.target.value))} />
                                        <div className="flex justify-between items-center w-full">
                                            <span className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">Min ($0)</span>
                                            <span className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">Max ($110)</span>
                                        </div>
                                    </div>
                                    <center> <span className="badge bg-gray-600 text-[#fff]">{item.subtype} #{item.mask}  </span> </center>
                                </div>
                            </div>
                        ))}

                    </form>
                </div>
            </div>
            <div className="fixed inset-x-0 bottom-0 flex flex-col justify-between gap-x-8 gap-y-4 bg-white p-6 ring-1 ring-gray-900/10 md:flex-row md:items-center lg:px-8">
                <a onClick={() => setStepper(1)} className="text-sm font-semibold text-gray-900 hover:text-blue-700 cursor-pointer">Back</a>
                <p className="max-w-4xl text-sm leading-6 text-gray-900"></p>
                <div className="flex flex-none items-center gap-x-5">
                    <button onClick={handleFormSubmit} type="button" className="cursor-pointer bg-gray-700 hover:bg-gray-700 text-white font-bold py-4 px-8 rounded-full mx-auto">Continue</button>
                </div>
            </div>
        </>
    )
}
export default Stepper2